import clsx from 'clsx';
import { PrismicRichText } from '@prismicio/react';
import * as prismicH from '@prismicio/helpers';
import getSSP from '../../lib/getServerSideProps';
import { showDatePeriodMonth } from '../../lib/date_helpers';
import PageComponent from '../../components/Page';
import { Heading } from '../../components/Heading';
import { Bounded } from '../../components/Bounded';
import { Tentative } from '../../components/Tentative';
import ProjectStatus from '../../components/ProjectStatus';
import COUNTRIES from '../../lib/countries';

const Page = (props) => {
  const { page } = props;
  return (
    <PageComponent {...props}>
      <Bounded as="section">
        <div className="py-5">
          <Heading as="h1" className="mb-3">
            {prismicH.asText(page.data.title)}
          </Heading>
          <div className="row">
            <div className="col-lg-8">
              <PrismicRichText field={page.data.summary} />
            </div>
            <div className="col-lg-4">
              {(page.data.countries || []).length > 0 && (
                <div className="mb-2">
                  {page.data.countries.map((country) => (
                    <div key={country.code}>
                      {COUNTRIES[country.code].flag}{' '}
                      {COUNTRIES[country.code].name}
                    </div>
                  ))}
                </div>
              )}
              <ProjectStatus project={page.data} className="mb-2" />
              <div
                className={clsx(
                  'mb-2',
                  page.data.dates_tentative && 'text-muted'
                )}>
                {showDatePeriodMonth(
                  page.data.start_date || page.data.year,
                  page.data.end_date
                )}
                {page.data.dates_tentative && <Tentative className="ms-2" />}
              </div>
            </div>
          </div>
        </div>
      </Bounded>
    </PageComponent>
  );
};

export default Page;

export const getServerSideProps = getSSP('project');
